export const MappingAutoMatchThresholdValue = {
  Low: 0.85,
  Medium: 0.75,
  High: 0.6,
  Exact: 0.35,
} as const;

export enum MappingAutoMatchThreshold {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
  Exact = 'Exact',
}

export interface Mapping {
  id: string;
  localId: number;
  path: string;
}

export const FindMatchThreshold = 0.95;
